import React from "react";
import styled from "styled-components";
import { ReactComponent as DropdownIcon } from "../../../../assets/images/icons/Chevron.svg";

export default function SidebarSection({ title, collapsed, toggle, children }) {
    return (
        <div style={{ marginBottom: 18 }}>
            <TitleRow onClick={toggle}>
                <span>{title}</span>
                {title !== "Guestbook" && <Chevron isopen={!collapsed ? "true" : "false"} />}
            </TitleRow>

            {!collapsed && (
                <OptionsWrap>
                    <VerticalLine />
                    <OptionList>{children}</OptionList>
                </OptionsWrap>
            )}
        </div>
    );
}

const TitleRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1.6px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 15px;
    cursor: pointer;
    margin-left: 15px;
`;

const OptionsWrap = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 10px;
`;

const Chevron = styled(DropdownIcon)`
    cursor: pointer;
    width: 12px;
    height: 12px;
    transition: transform 240ms ease;
    transform: ${(props) => (props.isopen === "true" ? "rotate(180deg)" : "rotate(0deg)")};
    margin: 0px 20px;
`;

const VerticalLine = styled.div`
    width: 1px;
    border-radius: 2px;
    margin-left: 15px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 100%, rgba(255, 255, 255, 0.05) 100%);
`;

const OptionList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
